module.exports = __webpack_public_path__ + "img/morning-and-evening-usage-active-icon.9862f97b.svg";